import { createAction } from 'redux-actions';

const namespace = 'CURRENT_USER';
export const ActionConstants = {
  SET_ID: `${namespace}/SET_ID`,
  SET_TYPE: `${namespace}/SET_TYPE`,
  UPDATE_AUTH: `${namespace}/UPDATE_AUTH`,
  UPDATE_SETTINGS: `${namespace}/UPDATE_SETTINGS`,
  CLEAR_AUTH: `${namespace}/CLEAR_AUTH`,
  LOGIN: `${namespace}/LOGIN`,
  LOGOUT: `${namespace}/LOGOUT`,
};

const setId = createAction(ActionConstants.SET_ID);
const updateSettings = createAction(ActionConstants.UPDATE_SETTINGS);
const updateAuth = createAction(ActionConstants.UPDATE_AUTH);
const clearAuth = createAction(ActionConstants.CLEAR_AUTH);
const setType = createAction(ActionConstants.SET_TYPE);
const login = createAction(ActionConstants.LOGIN);
const logout = createAction(ActionConstants.LOGOUT);

export default {
  clearAuth,
  updateAuth,
  updateSettings,
  setId,
  setType,
  login,
  logout,
};



// WEBPACK FOOTER //
// ./src/redux-modules/current-user/actions/index.js